// Channel integration guides - step by step instructions for each channel
const CHANNEL_GUIDES = {
  instagram: {
    title: { tr: 'Instagram Entegrasyonu', en: 'Instagram Integration' },
    devUrl: 'https://developers.facebook.com/apps/',
    devLabel: 'Meta Developer Portal',
    timeEstimate: '5-10 min',
    steps: {
      tr: [
        {
          title: 'Meta Developer hesabı oluşturun',
          desc: 'developers.facebook.com adresine gidin ve Facebook hesabınızla giriş yapın. "Uygulama Oluştur" butonuna tıklayın.',
        },
        {
          title: 'Uygulama türü olarak "Business" seçin',
          desc: 'Uygulama oluşturma sihirbazında "Business" (İşletme) tipini seçin ve uygulamanıza bir isim verin.',
        },
        {
          title: 'Instagram Graph API\'yi ekleyin',
          desc: 'Uygulama panelinde "Ürün Ekle" kısmından "Instagram Graph API" bulun ve "Kur" butonuna tıklayın.',
        },
        {
          title: 'Instagram Business hesabınızı bağlayın',
          desc: 'Instagram hesabınızın bir Facebook sayfasına bağlı ve "Business" veya "Creator" hesap olması gerekir. Bunu Instagram > Ayarlar > Hesap > Profesyonel hesaba geç kısmından yapabilirsiniz.',
        },
        {
          title: 'Access Token alın',
          desc: 'Graph API Explorer\'a gidin (developers.facebook.com/tools/explorer). Uygulamanızı seçin, "instagram_basic", "instagram_content_publish", "pages_read_engagement" izinlerini ekleyin ve token oluşturun.',
        },
        {
          title: 'Business Account ID\'yi bulun',
          desc: 'Graph API Explorer\'da "me/accounts" sorgusu yapın. Dönen sayfa ID\'sini kullanarak "{page-id}?fields=instagram_business_account" sorgusu yapın. Dönen ID sizin Instagram Business Account ID\'nizdir.',
        },
      ],
      en: [
        {
          title: 'Create a Meta Developer account',
          desc: 'Go to developers.facebook.com and log in with your Facebook account. Click "Create App".',
        },
        {
          title: 'Select "Business" as app type',
          desc: 'In the app creation wizard, select "Business" type and give your app a name.',
        },
        {
          title: 'Add Instagram Graph API',
          desc: 'In your app dashboard, find "Instagram Graph API" under "Add Products" and click "Set Up".',
        },
        {
          title: 'Connect your Instagram Business account',
          desc: 'Your Instagram account must be linked to a Facebook Page and be a "Business" or "Creator" account.',
        },
        {
          title: 'Get Access Token',
          desc: 'Go to Graph API Explorer (developers.facebook.com/tools/explorer). Select your app, add required permissions, and generate token.',
        },
        {
          title: 'Find Business Account ID',
          desc: 'In Graph API Explorer, query "me/accounts", then use the page ID to query "{page-id}?fields=instagram_business_account".',
        },
      ],
    },
    fieldHelp: {
      access_token: {
        tr: 'Graph API Explorer\'dan aldığınız uzun süreli erişim token\'ı',
        en: 'Long-lived access token from Graph API Explorer',
      },
      instagram_business_account_id: {
        tr: 'Instagram Business hesap numaranız (sayısal ID)',
        en: 'Your Instagram Business account numeric ID',
      },
    },
  },

  youtube: {
    title: { tr: 'YouTube Entegrasyonu', en: 'YouTube Integration' },
    devUrl: 'https://console.cloud.google.com/',
    devLabel: 'Google Cloud Console',
    timeEstimate: '10-15 min',
    steps: {
      tr: [
        {
          title: 'Google Cloud projesi oluşturun',
          desc: 'console.cloud.google.com adresine gidin. "Yeni Proje" oluşturun veya mevcut bir projeyi seçin.',
        },
        {
          title: 'YouTube Data API v3\'ü etkinleştirin',
          desc: 'Sol menüden "APIs & Services" > "Library" kısmına gidin. "YouTube Data API v3" arayın ve "Enable" butonuna tıklayın.',
        },
        {
          title: 'OAuth 2.0 kimlik bilgileri oluşturun',
          desc: '"APIs & Services" > "Credentials" > "Create Credentials" > "OAuth client ID" seçin. Uygulama türü olarak "Web application" seçin.',
        },
        {
          title: 'API Key oluşturun',
          desc: '"Credentials" sayfasında "Create Credentials" > "API key" seçin. Bu anahtarı güvenli bir yerde saklayın.',
        },
        {
          title: 'OAuth onay ekranını yapılandırın',
          desc: '"OAuth consent screen" kısmını doldurun. Test kullanıcıları ekleyin. Gerekli scope\'ları (youtube.upload, youtube.force-ssl) ekleyin.',
        },
        {
          title: 'Access ve Refresh Token alın',
          desc: 'OAuth 2.0 Playground (developers.google.com/oauthplayground) kullanarak YouTube Data API v3 scope\'ları için token alın.',
        },
      ],
      en: [
        {
          title: 'Create a Google Cloud project',
          desc: 'Go to console.cloud.google.com. Create a new project or select an existing one.',
        },
        {
          title: 'Enable YouTube Data API v3',
          desc: 'Go to "APIs & Services" > "Library". Search for "YouTube Data API v3" and click "Enable".',
        },
        {
          title: 'Create OAuth 2.0 credentials',
          desc: '"APIs & Services" > "Credentials" > "Create Credentials" > "OAuth client ID". Select "Web application".',
        },
        {
          title: 'Create an API Key',
          desc: 'In "Credentials" page, "Create Credentials" > "API key". Store this key securely.',
        },
        {
          title: 'Configure OAuth consent screen',
          desc: 'Fill in "OAuth consent screen". Add test users and required scopes.',
        },
        {
          title: 'Get Access and Refresh Tokens',
          desc: 'Use OAuth 2.0 Playground (developers.google.com/oauthplayground) to get tokens for YouTube API.',
        },
      ],
    },
    fieldHelp: {
      api_key: { tr: 'Google Cloud Console\'dan oluşturduğunuz API anahtarı', en: 'API key from Google Cloud Console' },
      channel_id: { tr: 'YouTube kanal ID\'niz (youtube.com/account_advanced sayfasında bulabilirsiniz)', en: 'Your YouTube channel ID (find at youtube.com/account_advanced)' },
      access_token: { tr: 'OAuth 2.0 erişim token\'ı', en: 'OAuth 2.0 access token' },
      refresh_token: { tr: 'OAuth 2.0 yenileme token\'ı (token süresi dolunca otomatik yenilenir)', en: 'OAuth 2.0 refresh token (auto-renews expired tokens)' },
      client_id: { tr: 'OAuth client ID (Credentials sayfasından)', en: 'OAuth client ID (from Credentials page)' },
      client_secret: { tr: 'OAuth client secret (Credentials sayfasından)', en: 'OAuth client secret (from Credentials page)' },
    },
  },

  twitter: {
    title: { tr: 'X (Twitter) Entegrasyonu', en: 'X (Twitter) Integration' },
    devUrl: 'https://developer.twitter.com/en/portal/dashboard',
    devLabel: 'Twitter Developer Portal',
    timeEstimate: '5-10 min',
    steps: {
      tr: [
        {
          title: 'Twitter Developer hesabı oluşturun',
          desc: 'developer.twitter.com adresine gidin ve "Sign up" yapın. Geliştirici başvurusunu tamamlayın.',
        },
        {
          title: 'Proje ve Uygulama oluşturun',
          desc: 'Developer Portal\'da "Projects & Apps" > "Overview" kısmından yeni bir proje ve uygulama oluşturun.',
        },
        {
          title: 'Uygulama izinlerini ayarlayın',
          desc: 'Uygulama ayarlarında "User authentication settings" kısmından "Read and Write" izinlerini aktifleştirin.',
        },
        {
          title: 'API Key ve Secret alın',
          desc: 'Uygulama "Keys and tokens" sekmesinden "API Key" ve "API Key Secret" değerlerini kopyalayın.',
        },
        {
          title: 'Access Token oluşturun',
          desc: 'Aynı sayfada "Access Token and Secret" bölümünden "Generate" butonuna tıklayın. Bu token\'lar sizin hesabınız adına tweet atmanızı sağlar.',
        },
      ],
      en: [
        {
          title: 'Create Twitter Developer account',
          desc: 'Go to developer.twitter.com and sign up. Complete the developer application.',
        },
        {
          title: 'Create a Project and App',
          desc: 'In Developer Portal, go to "Projects & Apps" > "Overview" and create a new project and app.',
        },
        {
          title: 'Set app permissions',
          desc: 'In app settings, go to "User authentication settings" and enable "Read and Write" permissions.',
        },
        {
          title: 'Get API Key and Secret',
          desc: 'From the app\'s "Keys and tokens" tab, copy "API Key" and "API Key Secret".',
        },
        {
          title: 'Generate Access Token',
          desc: 'On the same page, click "Generate" under "Access Token and Secret". These tokens let you post on behalf of your account.',
        },
      ],
    },
    fieldHelp: {
      api_key: { tr: 'Twitter API Key (Consumer Key)', en: 'Twitter API Key (Consumer Key)' },
      api_secret: { tr: 'Twitter API Secret (Consumer Secret)', en: 'Twitter API Secret (Consumer Secret)' },
      access_token: { tr: 'Hesabınız için oluşturulan Access Token', en: 'Access Token generated for your account' },
      access_token_secret: { tr: 'Access Token Secret değeri', en: 'Access Token Secret value' },
    },
  },

  facebook: {
    title: { tr: 'Facebook Entegrasyonu', en: 'Facebook Integration' },
    devUrl: 'https://developers.facebook.com/apps/',
    devLabel: 'Meta Developer Portal',
    timeEstimate: '5-10 min',
    steps: {
      tr: [
        {
          title: 'Meta Developer uygulaması oluşturun',
          desc: 'developers.facebook.com > "Uygulama Oluştur" > "Business" tipini seçin.',
        },
        {
          title: 'Facebook Pages API\'yi ekleyin',
          desc: 'Uygulama panelinde "Ürün Ekle" > "Facebook Login" ve "Pages API" ekleyin.',
        },
        {
          title: 'Sayfa Access Token alın',
          desc: 'Graph API Explorer\'a gidin. "pages_manage_posts" ve "pages_read_engagement" izinlerini ekleyin. Token oluşturun ve sayfanız için sayfa token\'ını alın.',
        },
        {
          title: 'Sayfa ID\'sini bulun',
          desc: 'Graph API Explorer\'da "me/accounts" sorgusu yapın. Yayın yapmak istediğiniz sayfanın ID\'sini kopyalayın.',
        },
      ],
      en: [
        {
          title: 'Create Meta Developer app',
          desc: 'developers.facebook.com > "Create App" > Select "Business" type.',
        },
        {
          title: 'Add Facebook Pages API',
          desc: 'In app dashboard, "Add Products" > add "Facebook Login" and "Pages API".',
        },
        {
          title: 'Get Page Access Token',
          desc: 'Go to Graph API Explorer. Add permissions and generate token for your page.',
        },
        {
          title: 'Find Page ID',
          desc: 'In Graph API Explorer, query "me/accounts" and copy the ID of your target page.',
        },
      ],
    },
    fieldHelp: {
      access_token: { tr: 'Facebook sayfa erişim token\'ı (Page Access Token)', en: 'Facebook Page Access Token' },
      page_id: { tr: 'Yayın yapacağınız Facebook sayfasının ID\'si', en: 'ID of the Facebook page to publish to' },
    },
  },

  whatsapp: {
    title: { tr: 'WhatsApp Entegrasyonu', en: 'WhatsApp Integration' },
    devUrl: 'https://business.facebook.com/settings/whatsapp-business-accounts/',
    devLabel: 'WhatsApp Business Platform',
    timeEstimate: '10-15 min',
    steps: {
      tr: [
        {
          title: 'Meta Business hesabı oluşturun',
          desc: 'business.facebook.com adresine gidin ve bir işletme hesabı oluşturun veya mevcut hesabınızla giriş yapın.',
        },
        {
          title: 'WhatsApp Business API uygulaması oluşturun',
          desc: 'Meta Developer Portal\'da yeni bir uygulama oluşturun ve "WhatsApp" ürününü ekleyin.',
        },
        {
          title: 'Test telefon numarası alın',
          desc: 'WhatsApp > Getting Started kısmından size verilen test telefon numarasını ve Phone Number ID\'sini not edin.',
        },
        {
          title: 'Access Token alın',
          desc: 'WhatsApp > API Setup kısmından geçici veya kalıcı Access Token oluşturun.',
        },
        {
          title: 'Alıcı numarasını ekleyin',
          desc: 'Test aşamasında mesaj göndereceğiniz numaraları "To" alanına ekleyin ve doğrulayın.',
        },
      ],
      en: [
        {
          title: 'Create Meta Business account',
          desc: 'Go to business.facebook.com and create or log in to your business account.',
        },
        {
          title: 'Create WhatsApp Business API app',
          desc: 'In Meta Developer Portal, create a new app and add "WhatsApp" product.',
        },
        {
          title: 'Get test phone number',
          desc: 'In WhatsApp > Getting Started, note the test phone number and Phone Number ID.',
        },
        {
          title: 'Get Access Token',
          desc: 'In WhatsApp > API Setup, generate a temporary or permanent Access Token.',
        },
        {
          title: 'Add recipient number',
          desc: 'During testing, add and verify the numbers you want to send messages to.',
        },
      ],
    },
    fieldHelp: {
      access_token: { tr: 'WhatsApp Business API erişim token\'ı', en: 'WhatsApp Business API access token' },
      phone_number_id: { tr: 'Meta Developer Portal\'dan aldığınız Phone Number ID', en: 'Phone Number ID from Meta Developer Portal' },
    },
  },

  telegram: {
    title: { tr: 'Telegram Entegrasyonu', en: 'Telegram Integration' },
    devUrl: 'https://t.me/BotFather',
    devLabel: 'Telegram BotFather',
    timeEstimate: '2-3 min',
    steps: {
      tr: [
        {
          title: 'BotFather\'a gidin',
          desc: 'Telegram\'da @BotFather botunu arayın ve sohbet başlatın. "/start" yazın.',
        },
        {
          title: 'Yeni bot oluşturun',
          desc: '"/newbot" komutunu gönderin. BotFather sizden bot adı ve kullanıcı adı isteyecek. Kullanıcı adı "_bot" ile bitmeli.',
        },
        {
          title: 'Bot Token\'ı kopyalayın',
          desc: 'BotFather size "Use this token to access the HTTP API" mesajıyla bir token verecek. Bu token\'ı kopyalayın (örn: 123456:ABC-DEF1234...).',
        },
        {
          title: 'Chat ID\'yi bulun',
          desc: 'Botunuza Telegram\'dan bir mesaj gönderin. Sonra tarayıcıda şu adresi açın: https://api.telegram.org/bot<TOKEN>/getUpdates — "chat" > "id" değerini kopyalayın.',
        },
        {
          title: 'Grup/Kanal için Chat ID (opsiyonel)',
          desc: 'Botu gruba/kanala ekleyin, grupta bir mesaj yazın, ardından getUpdates ile grup chat ID\'sini alın (genelde negatif sayı olur, örn: -1001234567890).',
        },
      ],
      en: [
        {
          title: 'Open BotFather',
          desc: 'Search for @BotFather on Telegram and start a chat. Type "/start".',
        },
        {
          title: 'Create a new bot',
          desc: 'Send "/newbot" command. BotFather will ask for a name and username. Username must end with "_bot".',
        },
        {
          title: 'Copy the Bot Token',
          desc: 'BotFather will send you a token like "123456:ABC-DEF1234...". Copy this token.',
        },
        {
          title: 'Find your Chat ID',
          desc: 'Send a message to your bot on Telegram. Then open: https://api.telegram.org/bot<TOKEN>/getUpdates — copy the "chat" > "id" value.',
        },
        {
          title: 'Group/Channel Chat ID (optional)',
          desc: 'Add the bot to your group/channel, send a message, then use getUpdates to find the group chat ID (usually negative, e.g. -1001234567890).',
        },
      ],
    },
    fieldHelp: {
      bot_token: { tr: 'BotFather\'dan aldığınız bot token\'ı (örn: 123456:ABC-DEF1234...)', en: 'Bot token from BotFather (e.g. 123456:ABC-DEF1234...)' },
      chat_id: { tr: 'Mesaj gönderilecek chat/grup/kanal ID\'si (getUpdates ile bulunur)', en: 'Chat/group/channel ID to send messages to (found via getUpdates)' },
    },
  },

  sms: {
    title: { tr: 'SMS (Twilio) Entegrasyonu', en: 'SMS (Twilio) Integration' },
    devUrl: 'https://console.twilio.com/',
    devLabel: 'Twilio Console',
    timeEstimate: '5-10 min',
    steps: {
      tr: [
        {
          title: 'Twilio hesabı oluşturun',
          desc: 'twilio.com adresine gidin ve ücretsiz deneme hesabı oluşturun. E-posta ve telefon doğrulamasını tamamlayın.',
        },
        {
          title: 'Account SID ve Auth Token alın',
          desc: 'Twilio Console ana sayfasında "Account Info" bölümünde Account SID ve Auth Token değerlerini göreceksiniz.',
        },
        {
          title: 'Telefon numarası alın',
          desc: 'Console > Phone Numbers > Buy a Number kısmından SMS gönderebilen bir numara satın alın (deneme hesabında ücretsiz verilir).',
        },
        {
          title: 'Doğrulanmış numaraları ekleyin',
          desc: 'Deneme hesabında sadece doğrulanmış numaralara SMS gönderebilirsiniz. Console > Verified Caller IDs kısmından numara ekleyin.',
        },
      ],
      en: [
        {
          title: 'Create Twilio account',
          desc: 'Go to twilio.com and create a free trial account. Complete email and phone verification.',
        },
        {
          title: 'Get Account SID and Auth Token',
          desc: 'On Twilio Console homepage, find Account SID and Auth Token under "Account Info".',
        },
        {
          title: 'Get a phone number',
          desc: 'Console > Phone Numbers > Buy a Number. Get an SMS-capable number (free on trial).',
        },
        {
          title: 'Add verified numbers',
          desc: 'On trial, you can only SMS verified numbers. Add them in Console > Verified Caller IDs.',
        },
      ],
    },
    fieldHelp: {
      account_sid: { tr: 'Twilio Account SID (AC ile başlar)', en: 'Twilio Account SID (starts with AC)' },
      auth_token: { tr: 'Twilio Auth Token (Console ana sayfasında)', en: 'Twilio Auth Token (on Console homepage)' },
      from_number: { tr: 'SMS gönderen Twilio numarası (+1234567890 formatında)', en: 'Twilio sender number (+1234567890 format)' },
    },
  },

  email: {
    title: { tr: 'E-posta (SMTP) Entegrasyonu', en: 'Email (SMTP) Integration' },
    devUrl: 'https://support.google.com/mail/answer/7126229',
    devLabel: 'SMTP Ayarları Rehberi',
    timeEstimate: '3-5 min',
    steps: {
      tr: [
        {
          title: 'SMTP sunucu bilgilerini belirleyin',
          desc: 'Gmail: smtp.gmail.com:587 | Outlook: smtp.office365.com:587 | Yahoo: smtp.mail.yahoo.com:587 | Yandex: smtp.yandex.com:465',
        },
        {
          title: 'Gmail için: Uygulama şifresi oluşturun',
          desc: 'Google Hesabı > Güvenlik > 2 Adımlı Doğrulama\'yı açın. Sonra "Uygulama şifreleri" kısmından "Mail" için bir şifre oluşturun. Normal şifreniz yerine bu şifreyi kullanın.',
        },
        {
          title: 'Outlook/Hotmail için',
          desc: 'Normal e-posta adresinizi ve şifrenizi kullanabilirsiniz. SMTP host: smtp.office365.com, Port: 587',
        },
        {
          title: 'Bağlantıyı test edin',
          desc: 'Bilgileri girdikten sonra "Bağlantıyı Test Et" butonuyla SMTP sunucusuna bağlantıyı doğrulayın.',
        },
      ],
      en: [
        {
          title: 'Determine SMTP server details',
          desc: 'Gmail: smtp.gmail.com:587 | Outlook: smtp.office365.com:587 | Yahoo: smtp.mail.yahoo.com:587 | Yandex: smtp.yandex.com:465',
        },
        {
          title: 'For Gmail: Create app password',
          desc: 'Google Account > Security > Enable 2-Step Verification. Then create an "App Password" for Mail. Use this instead of your regular password.',
        },
        {
          title: 'For Outlook/Hotmail',
          desc: 'Use your regular email and password. SMTP host: smtp.office365.com, Port: 587',
        },
        {
          title: 'Test the connection',
          desc: 'After entering details, click "Test Connection" to verify SMTP connection.',
        },
      ],
    },
    fieldHelp: {
      smtp_host: { tr: 'SMTP sunucu adresi (örn: smtp.gmail.com)', en: 'SMTP server address (e.g. smtp.gmail.com)' },
      smtp_port: { tr: 'SMTP port numarası (genelde 587 veya 465)', en: 'SMTP port number (usually 587 or 465)' },
      smtp_user: { tr: 'SMTP kullanıcı adı (genelde e-posta adresiniz)', en: 'SMTP username (usually your email address)' },
      smtp_password: { tr: 'SMTP şifresi veya uygulama şifresi', en: 'SMTP password or app password' },
      from_email: { tr: 'Gönderen e-posta adresi', en: 'Sender email address' },
    },
  },

  heygen: {
    title: { tr: 'HeyGen Video Entegrasyonu', en: 'HeyGen Video Integration' },
    devUrl: 'https://app.heygen.com/settings?nav=API',
    devLabel: 'HeyGen Dashboard',
    timeEstimate: '2-3 min',
    steps: {
      tr: [
        {
          title: 'HeyGen hesabı oluşturun',
          desc: 'app.heygen.com adresine gidin ve bir hesap oluşturun (ücretsiz deneme mevcut).',
        },
        {
          title: 'API sayfasına gidin',
          desc: 'Sol menüden "Settings" > "API" sekmesine tıklayın.',
        },
        {
          title: 'API Key oluşturun',
          desc: '"Generate API Key" butonuna tıklayın. Oluşturulan anahtarı kopyalayın ve güvenli bir yerde saklayın.',
        },
      ],
      en: [
        {
          title: 'Create HeyGen account',
          desc: 'Go to app.heygen.com and create an account (free trial available).',
        },
        {
          title: 'Go to API page',
          desc: 'Click "Settings" > "API" tab in the left menu.',
        },
        {
          title: 'Generate API Key',
          desc: 'Click "Generate API Key". Copy the key and store it securely.',
        },
      ],
    },
    fieldHelp: {
      api_key: { tr: 'HeyGen API anahtarınız (Settings > API sayfasından)', en: 'Your HeyGen API key (from Settings > API page)' },
    },
  },
};

export default CHANNEL_GUIDES;
